const state = {
    product: [],
    productID: [],
    loading: false,
    documents: [],
    file: null,
    docLoader: false,
};

export default state;